// extracted by mini-css-extract-plugin
module.exports = {"cards":"_2d9KW","card":"_15XtQ","headline":"_1JiD_","cover":"_103LX","title":"_1oNBo","summary":"_2Kd_u"};